var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('filter-item',{attrs:{"label":_vm.$t('common.labels.legislation'),"param-name":"legislation","items":_vm.legislationItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }